<template>
  <svg @click="click" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.41667 3H2V14H3.5V9.5C3.5 8.94772 3.94772 8.5 4.5 8.5H10.5C11.0523 8.5 11.5 8.94772 11.5 9.5V14H14V4.68435L12.2617 3H11.4167V5.45652C11.4167 6.00881 10.969 6.45652 10.4167 6.45652H4.41667C3.86438 6.45652 3.41667 6.00881 3.41667 5.45652V3ZM10.4167 3H9.08333V5.45652H10.4167V3ZM8.08333 5.45652H4.41667V3H8.08333V5.45652ZM10.5 14V9.5H4.5V14H10.5ZM1.5 2C1.22386 2 1 2.22386 1 2.5V14.5C1 14.7761 1.22386 15 1.5 15H14.5C14.7761 15 15 14.7761 15 14.5V4.47261C15 4.33727 14.9451 4.20771 14.8479 4.11353L12.8121 2.14091C12.7188 2.05054 12.594 2 12.4642 2H1.5Z"
          :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'arrowLeft',
  props: {
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    color() {
      if (this.disable) return '#E5E6EA'; else return '#111';
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
};
</script>
<style scoped lang="scss">
.icon {
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    filter: invert(0.7) brightness(1);
  }
}
</style>
